import { createFileRoute } from '@tanstack/react-router';
import { ComposePage } from '../components/mail/ComposePage';

interface ComposeSearch {
  listUuid?: string;
  draftUuid?: string;
}

export const Route = createFileRoute('/mail/compose')({
  validateSearch: (search: Record<string, unknown>): ComposeSearch => ({
    listUuid: typeof search.listUuid === 'string' ? search.listUuid : undefined,
    draftUuid: typeof search.draftUuid === 'string' ? search.draftUuid : undefined,
  }),
  component: ComposePageWrapper,
});

function ComposePageWrapper() {
  const { listUuid, draftUuid } = Route.useSearch();
  return <ComposePage preselectedListUuid={listUuid} preselectedDraftUuid={draftUuid} />;
}
